import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import logo from './logo.svg';
import './App.css';
import './styles/home.css'
import './styles/Components.css'
import IgApp from './IgApp';
import Loader from './components/Loader';
const StApp = React.lazy(() => import('./StApp'))

function App() {
  if (!('Notification' in window))
    return (
      <Router>
        <IgApp />
      </Router>
    )
  else
    return (
      <Suspense fallback={<Loader />} >
        <StApp />
      </Suspense>
    )

}

export default App;
